import { NavigationItem } from "@components/navigation/NavigationItem";
import { NavigationMenu } from "@components/navigation/NavigationMenu";
import { useActiveNavLink } from "@hooks/useActiveNavLink";
import { useSubmenuTransitionAnimation } from "@hooks/useSubmenuTransitionAnimation";
import { ActivityIcon, ProfileIcon } from "@icons";
import classNames from "classnames";
import { useCallback, useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";
import { OrganizationViewNavigationDropdown } from "./OrganizationViewNavigationDropdown";

export const OrganizationViewNavigation = () => {
    const navigationRef = useRef<HTMLDivElement>(null);
    const navigationContainerRef = useRef<HTMLDivElement>(null);
    const indicatorRef = useRef<HTMLDivElement>(null);
    const [isReady, setIsReady] = useState(false);

    const activeNavLink = useActiveNavLink(navigationRef.current);

    const calculateActiveLinkIndicatorPosition = useCallback(() => {
        if (!activeNavLink || !indicatorRef.current) {
            return;
        }

        const { offsetTop } = activeNavLink;
        indicatorRef.current.style.transform = `translateY(${offsetTop}px)`;

        setIsReady(true);
    }, [activeNavLink, indicatorRef]);

    const { isAnimationActive } = useSubmenuTransitionAnimation({
        onAnimationFrame: calculateActiveLinkIndicatorPosition,
    });

    useEffect(() => {
        calculateActiveLinkIndicatorPosition();
    }, [activeNavLink, calculateActiveLinkIndicatorPosition]);

    return (
        <nav className="navigation" ref={navigationContainerRef}>
            <header className="navigation__header">
                <OrganizationViewNavigationDropdown />
            </header>

            <div className="navigation__content" ref={navigationRef}>
                <NavigationMenu>
                    <div
                        ref={indicatorRef}
                        className={classNames("nav-indicator", {
                            "nav-indicator--ready": isReady,
                            "nav-indicator--submenu-animation-active":
                                isAnimationActive,
                        })}
                    />

                    <NavLink
                        to="/"
                        className={({ isActive }) =>
                            classNames({ active: isActive })
                        }
                    >
                        <NavigationItem icon={<ActivityIcon />}>
                            Clients
                        </NavigationItem>
                    </NavLink>

                    <NavLink
                        to="/team"
                        className={({ isActive }) =>
                            classNames({ active: isActive })
                        }
                    >
                        <NavigationItem icon={<ProfileIcon />}>
                            Team members
                        </NavigationItem>
                    </NavLink>
                </NavigationMenu>
            </div>
        </nav>
    );
};
